var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-header"},[_vm._t("title",[_c('span',[_vm._v(_vm._s(_vm.name))])]),_c('flex-spacer'),_c('collapse-button-group',[_vm._t("actions")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }